<template>
   <div class='Perdidas'>

    <div v-if="loading">
        <div class="d-flex justify-content-center mt-5">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>

    <div v-else>
        <div v-if="projectos == null">
            <div class="row pt-3">
                <div class="col">
                    <div class="card">
                        <p class="text-center pt-2">Sin Proyectos</p>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <!-- Tabla -->
            <table class="table">
            <thead>
                <tr>
                    <th scope="col" style="width: 25%">Nombre Proyecto</th>
                    <th scope="col">Solicitante</th>
                    <th scope="col">Pais</th>
                    <th scope="col">Fecha Adjudicacion</th>
                    <th scope="col">Monto</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="f in projectos" :key="f.id_oferta" :class="f.reoferta == '1' ? 'table-warning' : ''">
                    <td>
                        <router-link :to="{ name: 'DetalleProyecto', params: { idEmpresa: f.id_proyecto}}"> 
                            {{f.titulo_proyecto}}
                        </router-link>  
                    </td>
                    <td>
                        <div class="row">
                            <div class="col-sm-2">
                                <img :src="getUrl(f.avatar)" class="img">
                            </div>
                            <div class="col-sm-10">
                                <router-link :to="{ name: 'calificacion', params: {id: f.id_user}}">
                                    @{{f.usuario}}
                                </router-link>
                                <star-rating :increment="0.1" :rating="makeNumber(f.estrellas)" :star-size="20" :show-rating="false" :read-only="true"/>
                            </div>
                        </div>
                    </td>
                    <td>
                        <img :src="getBandera(f.pais_region)" class="bandera">
                    </td>
                    <td>
                        {{fechaFormat(f.fecha_adj)}}
                    </td>
                    <td>
                        ${{moneda(f.costo)}} ({{f.divisa}}) <br/>
                    </td>
                </tr>
            </tbody>
            </table>
        </div>
    </div>

   </div>
</template>


<script>
import { mapState } from 'vuex'
import { globalFunctions } from '@/hooks/globalFunctions'
import StarRating from 'vue-star-rating'

export default {
name: 'Perdidas',
components:{StarRating},
mixins: [ globalFunctions ],
data () {
    return {
        projectos: [],
        loading: true
    }
},
methods: {
    getData(){
        let data = {
            id: localStorage.userID,
            prop: 3,
            flag:3
        };
    
        this.axios.post(this.url + 'getProyectos.php',data).then((responce) =>{
            this.projectos = responce.data;
            this.loading = false;
        });
    }
},
computed:{
    ...mapState(['url'])
},
mounted(){
    this.getData();
}
}
</script>


<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/Proyectos/components/Consultor/Perdidas.vue